import { buildFamsPageMessages } from 'config/fams-menu';

export default {
  'pages.layouts.userLayout.title': 'こんにちは',
  'pages.getCaptchaSecondText': '秒後に再取得',
  'pages.404.subTitle': '申し訳ありません。お探しのページは存在しません。',
  'pages.404.buttonText': 'ホームへ戻る',
  ...buildFamsPageMessages('ja-JP'),
};
